/**
 * Render an error placeholder into the dropdown when the item list
 * cannot be fetched.
 *
 * @param dropdownUl - The dropdown `ul` to render the error into.
 */
export const renderListError = (dropdownUl: HTMLUListElement) => {
  dropdownUl.innerHTML = "";
  const errorItem = document.createElement("li");
  errorItem.classList.add("aiev3-drop-items-error");
  errorItem.textContent = "Error fetching list";
  dropdownUl.appendChild(errorItem);
};
